import PaymentMethod from "./PaymentMethod";
import CreatePaymentMethod from "./CreatePaymentMethod";
import EditPaymentMethod from "./EditPaymentMethod";
import ViewMorePaymentMethod from "./ViewMorePaymentMethod";

export {
  PaymentMethod,
  CreatePaymentMethod,
  EditPaymentMethod,
  ViewMorePaymentMethod,
};
